/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import a from"../BarChartMediaInfo.js";import r from"../ColumnChartMediaInfo.js";import e from"../ImageMediaInfo.js";import o from"../LineChartMediaInfo.js";import i from"../PieChartMediaInfo.js";import t from"../mixins/MediaInfo.js";const m={base:t,key:"type",defaultKeyValue:"image",typeMap:{"bar-chart":a,"column-chart":r,"line-chart":o,"pie-chart":i,image:e}};export{m as default,m as types};
